import * as React from 'react';
import { Container } from 'react-bootstrap';
import { TOSContent } from 'presentation/components/shared/TOSContent';
import { TechemBreadcrumb } from '@techem/ui-components';
import { t } from 'i18next';
import { paths } from 'frameworks_drivers/routes';
import { Trans } from 'react-i18next';

const TOSPage: React.FC = () => {
  return (
    <Container className="py-4 mb-5">
      <div className="my-4">
        <TechemBreadcrumb
          items={[
            {
              additionalTestId: 'home',
              href: `/#${paths.LandingPage}`,
              title: t('breadcrumbHome')
            }
          ]}
          currentPageTitle={t('breadcrumbTOS')}
        />
      </div>

      <h2
        className="text-start pe-4"
        style={{ fontSize: 40, lineHeight: '56px', marginBottom: 40 }}
      >
        <Trans i18nKey="breadcrumbTOS" />
      </h2>
      <TOSContent />
    </Container>
  );
};

export default TOSPage;
